import { render, staticRenderFns } from "./PayersGroupForm.vue?vue&type=template&id=d06f5b8a&scoped=true"
import script from "./PayersGroupForm.vue?vue&type=script&lang=js"
export * from "./PayersGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06f5b8a",
  null
  
)

export default component.exports